import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('General');

export const VEHICLECATEGORY_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.VehicleCategory.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('code', 'Entity.VehicleCategory.Code')
    .required()
    .minLength(1)
    .maxLength(9)
    .build(),
  FieldBuilder
    .number('semiTrailersQuantity', 'Entity.VehicleCategory.SemiTrailersQuantity')
    .build(),
];

export const VEHICLECATEGORY_CONFIG = {
  entityName: 'VehicleCategory',
  localizationKey: 'General::Entity.VehicleCategory',
  fields: VEHICLECATEGORY_FIELDS,
  permission: 'ControllingStructural.VehicleCategories',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Structural + MENU_NAME_SUFFIX,
};
